import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Utils } from '../../Services/Utils';
import StatusCard from './StatusCard';

const NotFoundComponent: React.FC = () => {
    useEffect(() => {
        Utils.setDocumentTitle('404');
    }, []);

    return (
        <StatusCard
            accentColor="var(--st-info)"
            code="404"
            title="Stránka nenájdená"
            text="Prepáčte, stránka, ktorú hľadáte, neexistuje alebo bola presunutá."
            action={
                <Link
                    to="/home"
                    className="st-btn st-btn--fill"
                    style={{ '--btn-accent': 'var(--st-info)' } as React.CSSProperties}
                >
                    <FontAwesomeIcon icon={faArrowLeft} className="st-status-action-icon" />
                    Späť na domov
                </Link>
            }
        />
    );
};

export default NotFoundComponent;
